import * as z from "@-/com.npmjs.zod";

export const morphemeTierSchema = z.literal([1, 2, 3]).nullable();

export type MorphemeTier = z.infer<typeof morphemeTierSchema>;
